import { Street } from '@dreryk/address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { StreetInput } from '@dreryk/react-components';

const STREET_FIELD_NAME = 'street';
const STREET_MAX_LENGTH = 50;

export type StreetFormBeanPart = {
   [STREET_FIELD_NAME]: Street | null;
};

type StreetFieldProps = {
   readonly required?: boolean;
   readonly register: BindingCreator<StreetFormBeanPart, typeof STREET_FIELD_NAME>;
};

export const StreetField = (props: StreetFieldProps): JSX.Element => {
   return (
      <StreetInput
         controller={props.register(STREET_FIELD_NAME, {
            required: props.required,
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu
             * react-components i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            maxLength: STREET_MAX_LENGTH,
         })}
         testId={STREET_FIELD_NAME}
      />
   );
};
